module.exports = __webpack_public_path__ + "img/atuuta_a_blue.14f331dd.svg";